import simg from '../images/service-single/1.jpg'
import simg2 from '../images/service-single/2.jpg'
import simg3 from '../images/service-single/3.jpg'
import simg4 from '../images/service-single/4.jpg'
import simg5 from '../images/service-single/5.jpg'
import simg6 from '../images/service-single/6.jpg'
import simg7 from '../images/service-single/7.jpg'
import simg8 from '../images/service-single/8.jpg'
import simg9 from '../images/service-single/9.jpg'
import simg10 from '../images/service-single/10.jpg'
import simg11 from '../images/service-single/11.jpg'
import simg12 from '../images/service-single/12.jpg'
import simg13 from '../images/service-single/13.jpg'

import sSingleimg1 from '../images/service-single/s1.jpg'
import sSingleimg2 from '../images/service-single/s2.jpg'


import ins1 from '../images/instragram/7.jpg'
import ins2 from '../images/instragram/8.jpg'
import ins3 from '../images/instragram/9.jpg'
import ins4 from '../images/instragram/10.jpg'
import ins5 from '../images/instragram/11.jpg'
import ins6 from '../images/instragram/12.jpg'


const Services = [
    {
        Id: '1',
        sImg:simg,
        sTitle: 'Proven Legacy Since 1956',
        description:'With over 60 years of excellence, Giga Group has built a legacy of trust, innovation, and sustainable growth across multiple industries and countries.',
        des2:'60+ years of excellence across multiple industries and countries.',
        des3:'Founded by Haji Abdul Rahim Giga in Dubai, UAE in 1956, Giga Group has evolved from a textile trading business into a multi-national conglomerate. Our proven track record spans real estate, commercial development, retail, and international trade.',
        icon:'fi flaticon-planning',
        ssImg1:sSingleimg1,
        ssImg2:sSingleimg2,
        sinst:ins1,
    },
    {
        Id: '2',
        sImg:simg2,
        sTitle: 'Multi-Sector Expertise',
        description:'From real estate development to gold refining, textile trading to retail management, our diverse portfolio demonstrates our ability to excel across industries.',
        des2:'Diverse expertise across real estate, retail, trading, and manufacturing.',
        des3:'Our multi-sector approach gives us unique insights and capabilities. We understand the interconnected nature of modern business and leverage our expertise in one sector to innovate in others, creating comprehensive solutions for our clients.',
        icon:'fi flaticon-blueprint',
        ssImg1:sSingleimg1,
        ssImg2:sSingleimg2,
        sinst:ins2,
    },
    {
        Id: '3',
        sImg:simg3,
        sTitle: 'International Standards',
        description:'Operating across Pakistan, UAE, and other countries, we bring world-class standards and international best practices to every project we undertake.',
        des2:'World-class standards from international operations and partnerships.',
        des3:'Our international presence allows us to benchmark against global best practices and bring cutting-edge solutions to local markets. We combine local expertise with international standards to deliver exceptional results.',
        icon:'fi flaticon-double-bed',
        ssImg1:sSingleimg1,
        ssImg2:sSingleimg2,
        sinst:ins3,
    },
    {
        Id: '4',
        sImg:simg4,
        sTitle: 'Iconic Project Portfolio',
        description:'From Giga Mall Islamabad to Goldcrest Views, our projects have become landmarks that define modern living and commercial excellence.',
        des2:'Landmark projects that define modern living and commercial excellence.',
        des3:'Our portfolio includes award-winning developments like Giga Mall Islamabad, Goldcrest Views, and Central Palace Residence. Each project showcases our commitment to innovation, quality, and creating spaces that enhance lives.',
        icon:'fi flaticon-armchair',
        ssImg1:sSingleimg1,
        ssImg2:sSingleimg2,
        sinst:ins4,
    },
    {
        Id: '5',
        sImg:simg5,
        sTitle: 'Comprehensive Development',
        description:'We don\'t just build structures; we create complete communities with integrated amenities, retail, entertainment, and lifestyle solutions.',
        des2:'Complete communities with integrated amenities and lifestyle solutions.',
        des3:'Our approach goes beyond construction to create vibrant, sustainable communities. We integrate retail, entertainment, healthcare, and lifestyle amenities to ensure our developments serve every need of modern living.',
        icon:'fi flaticon-furniture',
        ssImg1:sSingleimg1,
        ssImg2:sSingleimg2,
        sinst:ins5,
    },
    {
        Id: '6',
        sImg:simg6,
        sTitle: 'Customer-Centric Approach',
        description:'Your satisfaction drives everything we do. We work closely with clients to understand their vision and deliver solutions that exceed expectations.',
        des2:'Client satisfaction drives every decision and project outcome.',
        des3:'We believe in building lasting relationships with our clients. Our customer-centric approach ensures that every project is tailored to meet specific needs while maintaining the highest standards of quality and service.',
        icon:'fi flaticon-interior-design',
        ssImg1:sSingleimg1,
        ssImg2:sSingleimg2,
        sinst:ins6,
    },
    {
        Id: '7',
        sImg:simg7,
        sTitle: 'Sustainable Innovation',
        description:'We incorporate sustainable practices and innovative technologies to create developments that are environmentally responsible and future-ready.',
        des2:'Sustainable practices and innovative technologies for future-ready developments.',
        des3:'Sustainability is core to our development philosophy. We integrate green building practices, energy-efficient systems, and innovative technologies to create developments that respect the environment while meeting modern needs.',
        icon:'fi flaticon-interior-design',
        ssImg1:sSingleimg1,
        ssImg2:sSingleimg2,
        sinst:ins6,
    },
    {
        Id: '8',
        sImg:simg8,
        sTitle: 'Strategic Locations',
        description:'Our projects are strategically positioned in prime locations like DHA Phase II Islamabad, ensuring maximum value and convenience for our clients.',
        des2:'Prime locations that maximize value and convenience for clients.',
        des3:'Location is everything in real estate. We carefully select strategic sites that offer accessibility, growth potential, and lifestyle benefits. Our focus on prime locations ensures long-term value appreciation for our clients.',
        ssImg1:sSingleimg1,
        ssImg2:sSingleimg2,
        sinst:ins6,
    },
    {
        Id: '9',
        sImg:simg9,
        sTitle: 'Quality Assurance',
        description:'Every project undergoes rigorous quality control processes, ensuring that we deliver excellence in every detail, from foundation to finishing.',
        des2:'Rigorous quality control processes ensure excellence in every detail.',
        des3:'Quality is non-negotiable in our projects. We implement comprehensive quality assurance systems that monitor every stage of development, ensuring that our high standards are maintained throughout the entire process.',
        ssImg1:sSingleimg1,
        ssImg2:sSingleimg2,
        sinst:ins6,
    },
    {
        Id: '10',
        sImg:simg10,
        sTitle: 'After-Sales Excellence',
        description:'Our commitment doesn\'t end with project completion. We provide ongoing support, maintenance, and community management services.',
        des2:'Ongoing support, maintenance, and community management services.',
        des3:'We believe in long-term partnerships with our clients. Our after-sales services include property management, maintenance support, and community development initiatives that ensure continued satisfaction and value.',
        ssImg1:sSingleimg1,
        ssImg2:sSingleimg2,
        sinst:ins6,
    },
    {
        Id: '11',
        sImg:simg11,
        sTitle: 'Expert Team',
        description:'Our team of professionals brings decades of combined experience in real estate, construction, retail, and international business.',
        des2:'Decades of combined experience across multiple industries and disciplines.',
        des3:'Our success is built on the expertise of our people. From architects and engineers to business strategists and international trade experts, our team brings diverse skills and deep industry knowledge to every project.',
        ssImg1:sSingleimg1,
        ssImg2:sSingleimg2,
        sinst:ins6,
    },
    {
        Id: '12',
        sImg:simg12,
        sTitle: 'Innovation Leadership',
        description:'We continuously push boundaries in design, technology, and business models to stay ahead of market trends and deliver cutting-edge solutions.',
        des2:'Continuous innovation in design, technology, and business models.',
        des3:'Innovation is in our DNA. We constantly research and implement the latest trends in architecture, technology, and business practices to ensure our developments remain at the forefront of industry standards.',
        ssImg1:sSingleimg1,
        ssImg2:sSingleimg2,
        sinst:ins6,
    },
    {
        Id: '13',
        sImg:simg13,
        sTitle: 'Trusted Partnership',
        description:'With a reputation built over six decades, we are the trusted partner for investors, businesses, and families seeking quality and reliability.',
        des2:'Six decades of building trust through quality and reliability.',
        des3:'Trust is earned through consistent delivery of quality and value. Our long-standing reputation in the market makes us the preferred choice for clients who value reliability, transparency, and proven track records.',
        ssImg1:sSingleimg1,
        ssImg2:sSingleimg2,
        sinst:ins6,
    },
]
export default Services;